import React from 'react'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { useNavigate } from 'react-router-dom'
import MobileHeader from '../../../../components/MobileHeader/MobileHeader'
import { useSetHeaderTitle } from '../../../../hooks/hooks'
import { DashboardContent } from '../../DashboardLayout/DashboardLayout.styles'
import { useOpenScoreboardsQuery } from '../../../../services/api'
import { useProcessError } from '../../../../hooks/hooks'
import { animateComponent } from '../../../../utils/hoc'
import { ScoreboardList, ScoreboardLoadingState, ScoreboardEmptyState } from './ScoreboardComponents'
import ScoreboardDrawer from './ScoreboardDrawer'
import Button from '../../../../components/Button/Button'
import TextWithIcon from '../../../../components/TextWithIcon'
import AddIcon from '@mui/icons-material/Add'
import { colors } from '../../../../styles/_var'

const useScoreboardHome = () => {
  const navigate = useNavigate()
  const processError = useProcessError()
  const { data, error, isLoading } = useOpenScoreboardsQuery({})
  const [openScoreboardDrawer, setOpenScoreboardDrawer] = React.useState(false)
  const toggleScoreboardDrawer = () => setOpenScoreboardDrawer(!openScoreboardDrawer)
  const handleScoreboardClick = (id: number, slug: string) => void(navigate(`/scoreboards/${id}/${slug}`))
  const hasScoreboards = !!data?.payload?.length

  return {
    data,
    error,
    isLoading,
    hasScoreboards,
    openScoreboardDrawer,
    toggleScoreboardDrawer,
    handleScoreboardClick,
    processError,
  }
}

const ScoreboardHome = () => {
  useSetHeaderTitle('Scoreboards')
  const { 
    data, 
    error, 
    isLoading, 
    hasScoreboards, 
    openScoreboardDrawer, 
    toggleScoreboardDrawer, 
    handleScoreboardClick, 
    processError 
  } = useScoreboardHome()

  React.useEffect(() => {
    processError(error)
  }, [error, processError])


  return (
    <DashboardContent isMobile>
      <MobileHeader />
      <Container>
        <Box mt={3} mb={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={toggleScoreboardDrawer}
            center
          >
            <TextWithIcon
              color={colors.white}
              icon={<AddIcon />}
              weight="semibold"
            >
              Create Scoreboard
            </TextWithIcon>
          </Button>
        </Box>
        <Box>
          {isLoading ? (
            <ScoreboardLoadingState />
          ) : hasScoreboards ? (
            <ScoreboardList 
              scoreboards={data?.payload || []} 
              onScoreboardClick={handleScoreboardClick} 
            />
          ) : (
            <ScoreboardEmptyState />
          )}
        </Box>
      </Container>
      <ScoreboardDrawer isOpen={openScoreboardDrawer} closeDrawer={toggleScoreboardDrawer} />
    </DashboardContent>
  )
}

export default animateComponent(ScoreboardHome, true)
